export default __webpack_public_path__ + "static/media/JoGoDoBicho_Theme_1.7c7ba4d5.ogg";